var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46544 2.66531C6.51247 2.39097 6.75032 2.19043 7.02866 2.19043H12.9715C13.2499 2.19043 13.4877 2.39097 13.5347 2.66531L13.9919 5.33197L12.8654 5.52508L12.4897 3.33329H7.51046L7.13473 5.52508L6.0083 5.33197L6.46544 2.66531Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57141 5.42861C2.57141 5.11301 2.82725 4.85718 3.14284 4.85718H16.8571C17.1727 4.85718 17.4286 5.11301 17.4286 5.42861C17.4286 5.7442 17.1727 6.00003 16.8571 6.00003H3.14284C2.82725 6.00003 2.57141 5.7442 2.57141 5.42861Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63076 5.03777C4.73879 4.92255 4.88968 4.85718 5.04763 4.85718H14.9524C15.1103 4.85718 15.2612 4.92255 15.3693 5.03777C15.4773 5.15299 15.5328 5.30778 15.5226 5.4654L14.7607 17.2749C14.7413 17.5756 14.4918 17.8096 14.1905 17.8096H5.80953C5.50822 17.8096 5.25869 17.5756 5.23929 17.2749L4.47738 5.4654C4.46721 5.30778 4.52273 5.15299 4.63076 5.03777ZM5.65711 6.00003L6.34528 16.6667H13.6547L14.3429 6.00003H5.65711Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5238 14.1906C7.5238 13.875 7.77964 13.6191 8.09523 13.6191H11.9048C12.2203 13.6191 12.4762 13.875 12.4762 14.1906C12.4762 14.5062 12.2203 14.762 11.9048 14.762H8.09523C7.77964 14.762 7.5238 14.5062 7.5238 14.1906Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSmall);
export default __webpack_public_path__ + "static/media/delete_small.3cdea33400aa58383503f060349b9212.svg";
export { ForwardRef as ReactComponent };